/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import _ from "lodash";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select'
import { calendarFormat, caseInsensitiveSortBy, convertUrlsToLinks, dateWithOverdueColor, verifyRepeatedTask, verifyRepeatedTaskAsPerTodoist } from "../../../Components/action/utilities";
import TaskSourceIcon from "../../Tasks/TaskSourceIcon";
import RecurringIcon from "../../Tasks/RecurringIcon";
import ProjectTagIcon from "../../Tasks/ProjectTagIcon";
import { ArrowLeft, CalendarIconWithoutNumber, Cancel, CirclePlusIconWithoutStroke, MagnifyingGlassIcon, PlusIcon, ReloadIcon2 } from "../../../Components/LandingHeader/Feedback/icons/Icons";
import { updateSetTaskList } from "../../../redux/slices/TaskSlice";
import { setSetting, updateTaskList } from "../../../Components/action/common";
import { Link, useNavigate } from "react-router-dom";
import { pushToSetting } from "../../../redux/slices/SettingSclice";
import { fetchProjectList } from "../../../Components/action/tasks";
import { setAllProjectsList } from "../../../redux/slices/ProjectSlice";
import SortByDropdown from "../../../Components/common/SortByDropdown";
import toast from "react-hot-toast";
import UndoToaster from "../../../Components/common/UndoToaster";

const TaskTabs = () => {
    const taskList = useSelector(state => state.task.taskList);
    const [activeTab, setActiveTab] = useState('overdue');
    const [tasks, setTasks] = useState({});
    const [selectedProject, setSelectedProject] = useState(null);
    const [searchKey, setSearchKey] = useState('');
    const wrapperRef = useRef(null);
    const projectOptionsRef = useRef(null);
    const { colorPicker, colorPickerDark, theme } = useSelector(state => state.theme)
    const { allProjectsList } = useSelector(state => state.project)
    const settings = useSelector(state => state.settings.settings);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const dateFormat = settings?.dateFormat ? settings?.dateFormat : "DD/MM/YY";
    const [sort, setSort] = useState('desc')
    const [sortBy, setSortBy] = useState('date')

    useEffect(() => {
        const bound = wrapperRef.current.getBoundingClientRect()
        wrapperRef.current.style.height = window.innerHeight - bound.top + 'px'
    }, [])

    useEffect(() => {
        const todayStartTime = moment().startOf('day').toISOString();
        const todayEndTime = moment().endOf('day').toISOString();

        // Today tasks
        // const todayTasks = _.orderBy(taskList.map(item => {
        // if(item?.repeat?.rule){
        //     const result = verifyRepeatedTaskAsPerTodoist(item, new Date(), []);
        //     return result?.length > 0 ? {...item, date: new Date(result[0]).toISOString()} : false;
        // }else{
        //     const result = item.status == 0 && item.date !== null && item.date >= todayStartTime && item.date <= todayEndTime;
        //     return result ? item : false;
        // }
    
        //}).filter(item => item !== false && (selectedProject === null || item?.Project?.title === selectedProject)), ['date'], ['desc']);

        // No date tasks
        const noDateTasks = _.orderBy(taskList.map(item => {
            const result = item.status == 0 && item.date === null;
            return result ? item : false;
        
        }).filter(item => item !== false && (selectedProject === null || item?.Project?.title === selectedProject)), [sortBy], [sort]);

        // Overdue tasks
        const overdue = caseInsensitiveSortBy(taskList.map(item => {
        if(item?.repeat?.rule){
            const result = verifyRepeatedTask(item, null, [], true);
            return result?.length > 0 ? {...item, date: new Date(result[0]).toISOString()} : false;
        }else{
            const result = item.status == 0 && item.date !== null && item.date < todayStartTime;
            return result ? item : false;
        }

        }).filter(item => item !== false && (selectedProject === null || item?.Project?.title === selectedProject)), sortBy, sort);

        // Upcoming tasks
        const upcoming = _.orderBy(taskList.map(item => {
        if(item?.repeat?.rule){
            const result = verifyRepeatedTask(item, null, [], false, true);
            return result?.length > 0 ? {...item, date: new Date(result[0]).toISOString()} : false;
        }else{
            const result = item.status == 0 && item.date !== null && item.date > todayEndTime;
            return result ? item : false;
        }

        }).filter(item => item !== false && (selectedProject === null || item?.Project?.title === selectedProject)), [sortBy], [sort]);

        setTasks({
            //today: todayTasks,
            overdue: overdue,
            noDate: noDateTasks,
            upcoming: upcoming
        })
    }, [taskList, selectedProject, sort, sortBy])

    // Fetch projects list
    const getProjects = async () => {
        const {data} = await fetchProjectList();
        const projects = data?.responseData?.data ? data?.responseData?.data?.map(option => ({value: option.title, label: option.title})) : [];
        dispatch(setAllProjectsList(projects))
    }

    useEffect(() => {
        getProjects()
    }, [])

    const setTab = (e, tab) => {
        e.preventDefault();
        setActiveTab(tab)
    }
    const CustomStyle = {
        singleValue: (base, state) => {
          return {
            ...base,
            background: `linear-gradient(rgba(var(--theme-mode-rgb-white-reverse), 0.7), rgba(var(--theme-mode-rgb-white-reverse), 0.7)), var(--accent-color)`,
            WebkitTextFillColor: 'transparent',
            WebkitBackgroundClip: 'text !important'
          }
        },
       option: (base, state) => {
          let background = 'var(--theme-mode-color-white)';
          let color = 'var(--theme-mode-color-white-reverse)';
          let backgroundImage = 'none';
          let backgroundPosition = '0 0';
          let opacity = 1;
          const isFirstOption = state.options.indexOf(state.data) === 0;
          
          if (isFirstOption) {
            opacity = 0.5;
          }
    
          if (state.isFocused) {
            background = `linear-gradient(0deg,rgba(var(--theme-mode-rgb-white),0.9),rgba(var(--theme-mode-rgb-white),0.9)),var(--accent-color) !important`;
          }
    
          if (state.isSelected) {
            color = "white !important";
            background = `black url('data:image/svg+xml;charset=UTF-8,%3Csvg width%3D%2214%22 height%3D%2210%22 viewBox%3D%220 0 14 10%22 fill%3D%22none%22 xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath d%3D%22M13 1L4.75 9.25L1 5.5%22 stroke%3D%22${(theme == 'dark' ? colorPickerDark : colorPicker).replace(/^#/, '%23')}%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22/%3E%3C/svg%3E') no-repeat !important`;
            backgroundPosition = 'right 20px center !important';
          }
    
          return {
            ...base,
            color,
            background,
            backgroundImage,
            backgroundPosition,
            opacity
          };
        }
    } 

    const addTaskToToday = (e, task) => {
        e.preventDefault();
        setTaskToDate(task, new Date().toISOString());
    }

    const setTaskToDate = async (task, date, undone = false) => {
        let requestBody = {
          "id": task?.id,
          "title": task?.title,
          "date": date
        };
        
        try {
            await updateTaskList({...requestBody})
            dispatch(updateSetTaskList({...requestBody, undoDate: task?.date}));
            if(!undone){
                toast.custom(<UndoToaster icon={<ReloadIcon2 />} onUndoAction={() => setTaskToDate(task, task?.date, true)} />)
            }
        } catch ({ response }) {}
    }

    const reviewSelectedTasks = async (e) => {
        e.preventDefault();
        const newSettings = { ...settings, 'ritualsOk': moment().startOf('date').toISOString() };
        dispatch(pushToSetting(newSettings));

        try {
          await setSetting({ "settings": newSettings })
          navigate(process.env.REACT_APP_ROOT);
        } catch ({ response }) { }
    }

    return (
        <>
            <div className="flex-1 self-stretch inline-flex flex-col justify-start items-start gap-[10px]">
                <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
                    <div className="self-stretch justify-center dark:text-white text-black text-4xl font-normal font-['RL_Madena']">All tasks</div>
                    <div className="self-stretch justify-center text-base font-normal font-['Inter'] leading-normal dark-primary-color-60">Use the filters and search to choose what you’d like to get done today.</div>
                </div>
                <div className="self-stretch inline-flex justify-start items-center gap-2.5">
                    {/* <a href="#" className={`px-3.5 py-2 rounded-[40px] outline outline-1 outline-offset-[-0.50px] dark:outline-white/5 outline-black/5 flex items-center gap-2.5 justify-center text-xs font-medium font-['Inter'] task-list-filter-tab ${activeTab == 'today' ? 'active' : ''}`} onClick={e => setTab(e, 'today')}>
                        Today
                    </a> */}
                    <a href="#" className={`px-3.5 py-2 rounded-[40px] outline outline-1 outline-offset-[-0.50px] dark:outline-white/5 outline-black/5 flex items-center gap-2.5 justify-center text-xs font-medium font-['Inter'] task-list-filter-tab ${activeTab == 'overdue' ? 'active' : ''}`} onClick={e => setTab(e, 'overdue')}>
                        Overdue
                    </a>
                    <a href="#" className={`px-3.5 py-2 rounded-[40px] outline outline-1 outline-offset-[-0.50px] dark:outline-white/5 outline-black/5 flex items-center gap-2.5 justify-center text-xs font-medium font-['Inter'] task-list-filter-tab ${activeTab == 'noDate' ? 'active' : ''}`} onClick={e => setTab(e, 'noDate')}>
                        No Date
                    </a>
                    <a href="#" className={`px-3.5 py-2 rounded-[40px] outline outline-1 outline-offset-[-0.50px] dark:outline-white/5 outline-black/5 flex items-center gap-2.5 justify-center text-xs font-medium font-['Inter'] task-list-filter-tab ${activeTab == 'upcoming' ? 'active' : ''}`} onClick={e => setTab(e, 'upcoming')}>
                        Upcoming
                    </a>
                    <div ref={projectOptionsRef} className={`px-3.5 py-2 rounded-[40px] outline outline-1 outline-offset-[-0.50px] dark:outline-white/5 outline-black/5 flex items-center gap-2.5 justify-center text-xs font-medium font-['Inter'] cs-select projects-tags-dropdown text-black dark:text-white task-list-filter-tab`}
                        css={{
                        '.repeated-task-select': {
                            '.repeating-task-setting__menu-list': {
                            maxHeight: '300px !important'
                            }
                        },
                        '.tooltip-hover':{
                            '&:hover':{
                            '&::after':{
                                height: '75% !important'
                            }
                            }
                        },
                        '&.active': {
                            '.tooltip-hover':{
                            '&:hover':{
                                '&::after':{
                                display: 'none !important'
                                },
                                '~ span.tooltip-text':{
                                    display: 'none !important'
                                }
                            }
                            }
                        }
                    }}>
                        <Select
                            styles={CustomStyle}
                            placeholder="Project"
                            onChange={(value) => setSelectedProject(value.value)}
                            options={[{value: null, label: 'None'}, ...(allProjectsList ? allProjectsList : [] )]}
                            value={allProjectsList?.filter(option => option.value === selectedProject)?.[0] ?? null}
                            classNamePrefix={"repeating-task-setting"}
                            onMenuOpen={() => projectOptionsRef.current.classList.add('active')}
                            onMenuClose={() => projectOptionsRef.current.classList.remove('active')}
                            classNames={{container: () => 'react-select repeated-task-select', menu: () => 'dark:bg-black', option: () => 'dark:bg-black dark:text-white', singleValue: () => 'dark:text-white'}}
                        />
                    </div>
                    <div className="flex-1 flex justify-end items-center gap-2.5">
                        <SortByDropdown sort={sort} sortBy={sortBy} onSortChange={setSort} onSortByChange={setSortBy} />
                        <div className="w-48 h-8 px-3.5 py-2 rounded-[50px] outline outline-1 outline-offset-[-0.50px]  outline-black/5 dark:outline-white/5 flex justify-center items-center gap-2">
                            <input type="text" className="w-full bg-transparent flex-1 justify-center dark:text-white text-black placeholder:text-black/30 dark:placeholder:text-white/30 text-xs font-medium font-['Inter'] outline-none" placeholder="Search tasks..." onInput={e => setSearchKey(e.target.value)} value={searchKey} />
                            {searchKey?.length > 0 ? <button className="w-4 h-4 flex justify-center items-center" onClick={e => setSearchKey('')}><Cancel /></button> : <MagnifyingGlassIcon />}
                        </div>
                    </div>
                </div>
                <div className="w-full overflow-y-auto overflow-x-hidden" ref={wrapperRef}>
                    <ul className="ul-task-list">
                    {
                        tasks[activeTab]?.filter(task => task?.title?.toLowerCase()?.includes(searchKey?.toLowerCase())).map(task => (
                            <li key={task.id} className={`task-item li-task-list hr-line py-5 px-5 group ${task.id}`}
                                css={{
                                    '&:hover': {
                                        background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white), 0.9), rgba(var(--theme-mode-rgb-white), 0.9)), var(--accent-color) !important`,
                                    }
                                }}
                            >
                                <span
                                    className="title text-black dark:text-white group-hover:text-black dark:group-hover:text-white font-inter text-base">
                                    <div className="task-formatting">
                                        <span dangerouslySetInnerHTML={{__html: convertUrlsToLinks(task?.title)}} />
                                        {task?.description && <div className="task-description" dangerouslySetInnerHTML={{__html: convertUrlsToLinks(task?.description) ?? ''}} />}
                                    </div>
                                    <div className="flex items-center justify-start gap-[10px] mt-1">
                                        {
                                            activeTab == 'overdue' && task?.date !== null 
                                            && 
                                            <span className="task-deta">
                                                <CalendarIconWithoutNumber color={'var(--overDue-color)'} width={12} height={13} />
                                                <label className="ut-data text-gray-100 dark:text-white">
                                                { dateWithOverdueColor(moment(task?.date).startOf('day'), dateFormat) }
                                                </label>
                                            </span>
                                        }
                                        <TaskSourceIcon task={task} colorPicker={`var(--accent-color)`} />
                                        <RecurringIcon task={task} colorPicker={`var(--accent-color)`} />
                                        <ProjectTagIcon task={task} />
                                    </div>
                                </span>
                                {activeTab !== 'today' && <a href="#" onClick={e => addTaskToToday(e, task)} className="task-action border rounded-[50px] !border-black/5 dark:!border-white/5 flex items-center justify-center gap-[8px] py-2 px-[14px] h-[31px] hover:bg-black/5 dark:hover:bg-white/5"><PlusIcon /></a>}
                            </li>
                        ))
                    }
                    </ul>
                </div>
            </div>
            <div className="w-[200px] m-0 ml-auto mr-auto left-0 right-0 inline-flex justify-center items-center gap-2.5 !fixed bottom-[50px] !top-auto z-10">
                <Link to="/morning-rituals?step=journal" className="px-3.5 py-2.5 bg-white dark:bg-black rounded-[50px] outline outline-1 outline-white/5 flex justify-center items-center gap-2">
                    <ArrowLeft />
                </Link>
                <a href="#" onClick={reviewSelectedTasks} className="px-3.5 py-2.5 bg-black/50 rounded-[50px] outline outline-1 outline-offset-[-0.50px] outline-white/5 flex justify-center items-center gap-2 !text-white text-sm font-medium font-['Inter'] button primary dark-background-color !h-auto line-height-normal" css={{
                    svg:{
                        path:{
                            stroke: 'white !important'
                        }
                    }
                }}>
                    <div className="justify-center">Start my day</div>
                    <ArrowLeft right={true} />
                </a>
            </div>
        </>
    )
}

export default TaskTabs;